import {API} from '../backend';
import {CREATE_ORDER,CLEAR_CART,CLEAR_ORDER} from '../types';

export const createOrder = (order) =>  (dispatch) => {
   
     fetch(`${API}/api/orders`,{
         method : "POST",
         headers: {
             "Content-Type" : "application/json",
         },
         body: JSON.stringify(order)
     }).then( res => res.json())
       .then(data => {
           dispatch({type : CREATE_ORDER, payload : data});
           localStorage.clear("cartItems");
           dispatch({  type : CLEAR_CART   });

       })

     
}


export const clearOrder = () => (dispatch) => {
    dispatch({
        type :CLEAR_ORDER
    })
}